import React, { useState, useEffect } from 'react';

import { CustomerConstants } from '../../../Helpers/requests';
import { GetAuth } from '../../../Auth/AuthProvider';
import { APIROOT } from '../../../Helpers/configs';

import {
  findGuid,
  findGuidByName,
  filterMethod,
} from '../../../Helpers/helpers';

import {
  Grid,
  Typography,
  Autocomplete,
  TextField,
  Switch,
} from '@mui/material';

import { ticketTypoTitle, ticketTypoInfo } from '../../shared/commonStyle';

const RepairTicketCustomer = (props) => {
  const ticketId = props.ticketId;
  const customerInfo = props.customerInfo;
  const onCustomerInfoChange = props.onCustomerInfoChange;
  const onNameChange = props.onNameChange;

  //STATE
  const [categoriesData, setCategoriesData] = useState([]); //Constant - Categories List
  const [regionsData, setRegionsData] = useState([]); //Constant - Regions List
  const [asset_compData, setAsset_compData] = useState([]); //Constant - Asset Comp List
  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function
  const [selectedCategory, setSelectedCategory] = useState(
    customerInfo.category
  );
  const [selectedAssetComp, setSelectedAssetComp] = useState(
    customerInfo.assetComp
  );
  const [selectedStoreName, setSelectedStoreName] = useState(
    customerInfo.storeName
  );

  const [selectedStoreAddress, setSelectedStoreAddress] = useState(
    customerInfo.address
  );
  const [selectedStoreBranchCode, setSelectedStoreBranchCode] = useState(
    customerInfo.branchCode
  );

  const [filteredCustomers, setFilteredCustomers] = useState([]);

  const [notifyMe, setNotifyMe] = useState(customerInfo.notify);

  //GET CUSTOMERS LIST
  useEffect(() => {
    let category = selectedCategory;
    // let assetComp = selectedAssetComp;

    if (
      category === null ||
      category === undefined ||
      category === ''
      // ||
      // assetComp === null ||
      // assetComp === undefined ||
      // assetComp === ''
    ) {
      setFilteredCustomers([]);
    } else {
      getCustomerbyID(
        category.name
        // assetComp.name
      ).then((data) => {
        setFilteredCustomers(data.data.value);
      });
    }
  }, [
    selectedCategory,
    // selectedAssetComp
  ]);

  //SET CONSTANTS
  useEffect(() => {
    CustomerConstants({
      resource: `/api/constants/customer`,
      setCategoriesFunc: setCategoriesData,
      setRegionsFunc: setRegionsData,
      setAsset_compFunc: setAsset_compData,
      // setLoadingFunc: setLoading,
      showNotification: enqNotification,
      logout,
    });
  }, [enqNotification, logout]);

  // HANDLE CHANGES

  const handleChange = (event) => {
    const eventTarget = event.target;
    switch (eventTarget.id) {
      case 'notify':
        setNotifyMe(eventTarget.checked);
        onCustomerInfoChange(eventTarget.id, eventTarget.checked);
        break;
      case 'contactPerson':
        onCustomerInfoChange(eventTarget.id, eventTarget.value);
        break;
      case 'wiNr':
        onCustomerInfoChange(eventTarget.id, eventTarget.value);
        break;
      default:
        onCustomerInfoChange(eventTarget.id, eventTarget.value);
        break;
    }
  };

  const handleListChange = (event, newValue) => {
    const eventTarget = event.target.parentNode.id.split('-').shift();
    switch (eventTarget) {
      case 'storeName':
        onNameChange(newValue.name);
        onCustomerInfoChange('customerId', newValue.id);
        // onCustomerInfoChange('storeName', newValue.name);
        setAutocompleteValue(eventTarget, newValue);
        break;
      default:
        const eventValue = newValue.name;
        onCustomerInfoChange(eventTarget, eventValue);
        setAutocompleteValue(eventTarget, newValue);
        break;
    }
  };

  const setAutocompleteValue = (event, newValue) => {
    switch (event) {
      case 'category':
        setSelectedCategory(newValue);
        break;
      // case 'assetComp':
      //   setSelectedAssetComp(newValue);
      //   break;
      case 'storeName':
        setSelectedStoreName(newValue);
        setSelectedAssetComp(newValue.asset_man_comp_name);

        setSelectedStoreAddress(newValue.address);
        setSelectedStoreBranchCode(newValue.branchcode);
        break;
      default:
        break;
    }
  };

  // HANDLE CATEGORY
  useEffect(() => {
    let obj = findGuidByName(customerInfo.category, categoriesData);
    setSelectedCategory(obj);
  }, [categoriesData]);
  // HANDLE ASSET COMP
  // useEffect(() => {
  //   let obj = findGuidByName(customerInfo.assetComp, asset_compData);
  //   setSelectedAssetComp(obj);
  // }, [asset_compData]);
  // HANDLE STORE NAME
  useEffect(() => {
    let obj = findGuidByName(customerInfo.storeName, filteredCustomers);
    setSelectedStoreName(obj);
  }, [filteredCustomers]);

  return (
    <Grid
      container
      // justifyContent='space-between'
      // alignItems='center'
      flexDirection={{ xs: 'column', sm: 'row' }}
      sx={{ fontSize: '12px' }}
      xs={12}
      md={12}
      lg={12}
      spacing={0}
      rowGap={1}
    >
      <Grid
        container
        xs={12}
        md={6}
        flexDirection='row'
        rowGap={1}
        columnGap={1}
        alignContent='flex-start'
      >
        <Grid item xs={12} lg={2.5}>
          <Typography style={ticketTypoTitle}>Category:</Typography>
        </Grid>
        <Grid item xs={12} lg={7.5}>
          <Typography
            style={ticketTypoInfo}
            display={ticketId === null || undefined ? 'none' : true}
          >
            {/* {selectedCategory ? selectedCategory.name : ''} */}
            {customerInfo?.category ?? ''}
          </Typography>

          <Autocomplete
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
              display: ticketId !== null || undefined ? 'none' : true,
            }}
            name='category'
            key='category'
            id='category'
            variant='standard'
            size='small'
            value={selectedCategory}
            onChange={handleListChange}
            disablePortal
            options={categoriesData.sort((a, b) =>
              a.name > b.name ? 1 : b.name > a.name ? -1 : 0
            )}
            filterOptions={filterMethod}
            getOptionLabel={(option) => option.name || ''}
            renderInput={(params) => <TextField {...params} />}
            isOptionEqualToValue={(option, value) => {
              return option.name === value.name ? true : false;
            }}
          />
        </Grid>
        <Grid item xs={12} lg={2.5}>
          <Typography style={ticketTypoTitle}>Address:</Typography>
        </Grid>
        <Grid item xs={12} lg={7}>
          <Typography style={ticketTypoInfo}>{selectedStoreAddress}</Typography>
        </Grid>
        <Grid item xs={12} lg={2.5}>
          <Typography style={ticketTypoTitle}>Contact Person:</Typography>
        </Grid>
        <Grid item xs={12} lg={7}>
          <TextField
            id='contactPerson'
            size='small'
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
            }}
            required
            defaultValue={customerInfo.contactPerson}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} lg={2.5}>
          <Typography style={ticketTypoTitle}>Contact Number:</Typography>
        </Grid>
        <Grid item xs={12} lg={7}>
          <TextField
            size='small'
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
            }}
            required
            id='contactNumber'
            defaultValue={customerInfo.contactNumber}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} lg={2.5}>
          <Typography style={ticketTypoTitle}>Notify Me:</Typography>
        </Grid>
        <Grid item xs={6} lg={3}>
          <Typography>{notifyMe ? 'Notify' : "Don't Notify"}</Typography>
        </Grid>
        <Grid item xs={6} lg={3}>
          <Switch
            name='notify'
            id='notify'
            key='notify'
            checked={notifyMe}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
      <Grid
        container
        xs={12}
        md={6}
        flexDirection='row'
        rowGap={1}
        columnGap={1}
        alignContent='flex-start'
      >
        <Grid item xs={12} lg={4}>
          <Typography style={ticketTypoTitle}>Store/Customer Name:</Typography>
        </Grid>
        <Grid item xs={12} lg={7}>
          <Typography
            style={ticketTypoInfo}
            display={ticketId === null || undefined ? 'none' : true}
          >
            {/* {selectedStoreName ? selectedStoreName.name : ''} */}
            {customerInfo?.storeName ?? ''}
          </Typography>
          <Autocomplete
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
              display: ticketId !== null || undefined ? 'none' : true,
            }}
            name='storeName'
            key='storeName'
            id='storeName'
            variant='standard'
            size='small'
            value={selectedStoreName}
            onChange={handleListChange}
            disablePortal
            options={filteredCustomers.sort((a, b) =>
              a.name > b.name ? 1 : b.name > a.name ? -1 : 0
            )}
            filterOptions={filterMethod}
            getOptionLabel={(option) => option.name || ''}
            renderInput={(params) => <TextField {...params} />}
            isOptionEqualToValue={(option, value) => {
              return option.name === value.name ? true : false;
            }}
          />
        </Grid>

        <Grid item xs={12} lg={4}>
          <Typography style={ticketTypoTitle}>Branch Code:</Typography>
        </Grid>
        <Grid item xs={12} lg={7}>
          <Typography style={ticketTypoInfo}>
            {selectedStoreBranchCode}
          </Typography>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Typography style={ticketTypoTitle}>WI Nr:</Typography>
        </Grid>
        <Grid item xs={12} lg={7}>
          <TextField
            size='small'
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
            }}
            required
            id='wiNr'
            key='wiNr'
            name='wiNr'
            defaultValue={customerInfo.wiNr}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} lg={4}>
          <Typography style={ticketTypoTitle}>Asset Comp:</Typography>
        </Grid>
        <Grid item xs={12} lg={7}>
          {/* {'asset_man_comp_name'} */}
          {/* <Typography style={ticketTypoInfo}>{selectedAssetComp}</Typography> */}
          <Typography style={ticketTypoInfo}>{customerInfo?.assetComp ?? ''}</Typography>
          {/* <Autocomplete
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
            }}
            name='assetComp'
            key='assetComp'
            id='assetComp'
            variant='standard'
            size='small'
            value={selectedAssetComp}
            onChange={handleListChange}
            disablePortal
            options={asset_compData}
            // options={categoriesData}
            filterOptions={filterMethod}
            getOptionLabel={(option) => option.name || ''}
            renderInput={(params) => <TextField {...params} />}
            isOptionEqualToValue={(option, value) => {
              return option.name === value.name ? true : false;
            }}
          /> */}
        </Grid>
        <Grid item xs={12} lg={4}>
          <Typography style={ticketTypoTitle}>Ticket Logged By:</Typography>
        </Grid>
        <Grid item xs={12} lg={7}>
          <Typography style={ticketTypoInfo}>
            {customerInfo.loggedBy}
          </Typography>
        </Grid>
        {/* <Grid item xs={12} lg={4}>
          <Typography style={ticketTypoTitle}>Contact Nr:</Typography>
        </Grid>
        <Grid item xs={12} lg={7}>
          <Typography style={ticketTypoInfo}>
            {customerInfo.loggedByNumber}
          </Typography>
        </Grid> */}
      </Grid>
    </Grid>
  );
};

export default RepairTicketCustomer;

async function getCustomerbyID(searchCategory, searchAsset) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {
    pagereq: {
      filter: {
        fullfilter: [
          {
            field: 'category_name',
            search: searchCategory,
            strict: true,
          },
          {
            field: 'asset_man_comp_name',
            search: '%',
            strict: true,
          },
        ],
      },
    },
  };

  const request = new Request(`${APIROOT}/api/customersv2`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}
